import { Subscription } from 'rxjs';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { IState } from './../../shared/store/root.reducer';
import { Router } from '@angular/router';
import { User } from './../../shared/services/auth.service';
import { smoothlyMenu } from 'src/app/app.helper';
import { OpsFeatures } from 'src/app/ops-features';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, AfterViewInit, OnDestroy {
  navigationMenuCssClass: string;
  fullScreenSubscription: Subscription;
  searchCriteria: string;
  currentUser: User = <User>{};
  currentUserSubscription: Subscription;

  showSmartSearchSlider = 'false';

  theme = '';
  shopUser: boolean;
  supplierUser: boolean;
  showAccountSettingsLink: boolean;

  constructor(
    private router: Router,
    private store: Store<IState>,
    public opsFeatures: OpsFeatures
  ) { }

  ngOnInit() {
    this.searchCriteria = '';
    this.showSmartSearchSlider = 'false';
    this.fullScreenSubscription = this.store.pipe(select((store: IState) => store.fullScreen))
      .subscribe(fullScreenState => {
        this.navigationMenuCssClass = fullScreenState.navigationMenuCssClass;
      });

    this.currentUserSubscription = this.store.pipe(select((store: IState) => store.currentUser))
      .subscribe(currentUser => {
        if (currentUser.id > 0) {
          this.currentUser = currentUser;
          this.theme = this.currentUser.userType === 1 ? 'shop' : 'supplier' ;
          this.shopUser = this.currentUser.userType === 1;
          this.supplierUser = this.currentUser.userType === 2;
          if (currentUser.featuresCodes.filter(code => code === this.opsFeatures.codes.regularDiscounts
            || code === this.opsFeatures.codes.valutraxDiscounts || code === this.opsFeatures.codes.specialPricingDiscounts ).length > 0) {
              this.showAccountSettingsLink = true;
          }
        }
      });
  }

  goToSmartSearch() {
    this.showSmartSearchSlider = 'true';
  }
  onCloseSearch(event: string) {
    this.showSmartSearchSlider = 'false';
  }

  toggleNavigation(): void {
    const body = document.body;
    body.classList.toggle('mini-navbar');
    smoothlyMenu();
  }
  ngAfterViewInit() {
  }

  activeRoute(routename: string): boolean {
    return this.router.url.indexOf(routename) > -1;
  }

  ngOnDestroy() {
    if (this.fullScreenSubscription) {
      this.fullScreenSubscription.unsubscribe();
    }
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
  }
}
